export default {
	edit: 'Edit',
	delete: 'Delete',
	next_step: 'Next step',
	skip: 'Skip',
	view: 'View details',
	close: 'Close',
	send: 'Send'
};
